import axiosConfig from "./axiosConfig";

export interface OtherChargeItem {
  description: string;
  amount: number;
}

export interface SiteBillingRequest {
  reading_action: "current_month" | "last_month" | `month:${string}`;
  reading_db_insert: boolean;
  reading_db_update: boolean;
  attach_readings_file: boolean;
  site_tz_name?: string;
  invoice_format?: "pdf" | "docx";
  invoice_date?: string; // YYYY-MM-DD
  other_charge_items?: OtherChargeItem[];
}

export interface SiteBillingResponse {
  operationKey: string;
  status: "pending" | "running";
}

export interface BillingOperationResult {
  reading_db_update_stats: Record<string, Record<string, number>>;
  invoice_data: Record<string, unknown> | null;
  files_attached: Array<{ fileName: string }>;
}

const postSiteBilling = async (
  authToken: string,
  siteId: string,
  request: SiteBillingRequest
): Promise<SiteBillingResponse> => {
  const { data } = await axiosConfig.post(`/site/${siteId}/billing`, request, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default postSiteBilling;
